import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const EMAILS_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.DATCrusher,
  PlatformSlug.PATBooster,
  PlatformSlug.INBDEBooster,
  PlatformSlug.CasperBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher,
  PlatformSlug.CARSBooster,
  PlatformSlug.MCATBooster,
  PlatformSlug.GREBooster,
  PlatformSlug.NBEOPartOne,
  PlatformSlug.DLOSCE
)

export const isEmailsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(EMAILS_CONFIG, slug)
